import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getTimeOffListRequest = async (params = {}) => {
  const response: AxiosResponse = await apiInstance.get("/time-off/list", {
    params: {
      ...params,
    },
  });

  return response.data;
};
